var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "weixinLoginUser-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 130,
            model: _vm.edit,
            elem: _vm.weixinLoginUserElem,
            rules: _vm.weixinLoginUserRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "openid", prop: "openid" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入openid",
                              maxlength: "50",
                              disabled: true,
                            },
                            model: {
                              value: _vm.edit.openid,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "openid",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.openid",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "unionid", prop: "unionid" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入unionid",
                              maxlength: "50",
                              disabled: true,
                            },
                            model: {
                              value: _vm.edit.unionid,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "unionid",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.unionid",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "昵称", prop: "nickname" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入昵称",
                              maxlength: "20",
                              disabled: true,
                            },
                            model: {
                              value: _vm.edit.nickname,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "nickname",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.nickname",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "手机号码", prop: "mobile" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入手机号码",
                              maxlength: "15",
                            },
                            model: {
                              value: _vm.edit.mobile,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.edit,
                                  "mobile",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "edit.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }